export const SELECT_MENU_TRANSITION_DURATION_MILLIS = 150;
